/*
export const environment = {
  production: true,
  serviceId: 'jrb_service',
  templateId: 'template_lprgq2q',
  userId: 'user_l7K8KUCkZuiYlcBYVq1Mm'
};
*/
export const environment = {
  production: true,
  serviceId: 'service_cf6z938',
  templateId: 'template_5iwnegl',
  userId: 'Wwh1ksJ406B49mkNY'
};
